export const getInfoState = (state, key) => state.info[key];



/** WEBPACK FOOTER **
 ** ./src/members/state/info/selectors.js
 **/